import { Validators } from '@angular/forms';
import { BaseForm } from '../../core/forms/base.form';

export class AcademicTrainingDeclarationForm extends BaseForm {

    constructor() {
        super();
        this.validationForm = this.formBuilder.group({
            date: [null, Validators.required],
            duration: [null, Validators.required],
            description: [null]
        });
    }

    public toRequestForm() {
        return {
            date: this.validationForm.get('date').value,
            duration: this.validationForm.get('duration').value,
            description: this.validationForm.get('description').value,
        };
    }
}
